module.exports = __webpack_public_path__ + "img/navbar-2.698dbe53.png";